<template>
  <div class="">
    <coupon-popover :visible.sync="visibleCouponList"
                    @close="closeCouponPopoverBefore"
                    @closed="closedCallback">
      <div class="coupon-list"
           :class="{'is-scroll':couponList.length>=3}">
        <template v-for="(item,index) in couponList">
          <coupon-item class="coupon-li" :data="item">
            <template slot="tag">
              <span class="tag tag-red is-plain" v-if="item.status === 1">待领取</span>
              <span class="tag is-plain" v-if="item.status === 2">已领取</span>
            </template>
          </coupon-item>
        </template>
      </div>
      <template slot="footer">
        <get-coupon-button v-if="needAllotList.length"
                           button-text="立即领取"
                           @clickButton="clickAllot"></get-coupon-button>
        <get-coupon-button v-else
                           button-text="去使用"
                           @clickButton="clickUse"></get-coupon-button>
      </template>
    </coupon-popover>
  </div>
</template>

<script>
import CouponPopover from "../couponPopover";
import CouponItem from "../couponPopover/couponItem";
import GetCouponButton from "../couponPopover/getCouponButton";
import {isObject} from "my-tools-kit";
import { mapGetters } from 'vuex'

function getBaseDataCouponItem(opt,...arg){
  let data = {
    "couponId": "",//优惠券id:判断同一种优化券是否可叠加
    "couponRulesDescribe": "",//优惠券规则描述
    "couponRulesName": "",//优惠券规则名称
    "couponType": "FR",//优惠类型 FR-满减（max_amount:满多少费用才可以减 price：能减的优惠券金额）； DC-折扣（max_amount:最高折扣金额 price：折扣数）；CP-立减（price：能减的优惠券金额）
    "endTime": "",//有效期结束时间
    "id": "",//优惠券明细id
    "imgUrl": "",//优惠券背景图URL
    "isOverlay": true,//是否可叠加
    "maxAmount": 0,//最高折扣金额
    "price": 0,//价格
    "realPrice": 0,//真实减免金额
    "startTime": "",//有效期开始时间
    "status": 2,//领取状态:1-待领取 2-自动发放
  }
  if(opt) Object.assign(data,opt,...arg);
  return data;
}
export default {
  name: "getCoupon",
  components: {GetCouponButton, CouponItem, CouponPopover},
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        abc: ossPath + "/pages/home/coupon/abc.png",
      },
      // 显示优惠券领取弹窗
      visibleCouponList:false,
      // 新推送的优惠券列表
      couponList:[],
      // 需要手动领取的优惠券列表
      needAllotList:[],
      // 是否有发送过优惠券领取记录
      hasMarkCouponRecord:false,
    }
  },
  computed: {
    // ...mapGetters(['token'])
  },
  watch: {
    // token: {
    //   immediate: true,
    //   handler(val) {
    //     console.log("领取优惠券弹窗 watch token",`${val ? "需要" : "不用"}获取优惠券`)
    //     if(val) this.getCouponList()
    //   }
    // }
  },
  methods:{
    /**
     * 点击领取
     */
    clickAllot(){
      this.allotCoupon()
        // .then(res=>{
        //   this.clickUse();
        // })
    },
    /**
     * 点击去使用
     */
    clickUse(){
      this.markCouponRecord()
        .finally(()=>{
          this.hideCouponList();
        })
    },
    /**
     * 弹窗显示
     */
    showCouponList(){
      this.visibleCouponList = true;
    },
    /**
     * 弹窗隐藏
     */
    hideCouponList(){
      this.visibleCouponList = false;
    },
    /**
     * 关闭弹窗动画前
     */
    closeCouponPopoverBefore(){
      this.markCouponRecord();
    },
    /**
     * 关闭弹窗后回调
     */
    closedCallback(){
      this.hasMarkCouponRecord = false;
      this.couponList = [];
      this.needAllotList = [];
    },
    /**
     * 获取新推送优惠券列表
     */
    getCouponList(){
      const url = "/api/bns/findCouponSend";
      const data = {
        customerId:this.$store.getters.customerId,
      };
      // return this.getTestCouponList()
      return this.axios.get(url, {params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          // res = {code:200,message:"成功",data:null,datas:[{id:19503554800,couponId:19503539200,couponIssueId:19503547200,couponRulesName:"惊喜优惠patton",couponRulesDescribe:"惊喜优惠",startTime:null,endTime:null,imgUrl:"https://jiuyu-test.oss-cn-hongkong.aliyuncs.com/supplier/data/logo/1665991302105_NorwayRogalandhousesseaislandrockssunset5120x2880.jpg",isOverlay:true,price:300.000000,status:1,couponType:"CP",maxAmount:null,realPrice:null,expirationDateType:1,activeDay:1,issueDate:null,sort:3}]}
          let list  = res.datas||[];
          if(list.length){
            this.couponList = list;
            this.getNeedAllotList(list);
            this.showCouponList();
          }
        })
    },
    /**
     * 获取静态测试数据
     * @returns {Promise<{data: {code: number, datas: {couponRulesName: string, isOverlay: boolean, couponId: string, imgUrl: string, couponRulesDescribe: string, couponType: string, price: number, startTime: string, endTime: string, id: string, maxAmount: number, realPrice: number, status: number}[]}}>}
     */
    getTestCouponList(){
      let getOpt = function (){
        return {
          couponId: 'a'+Date.now(),
          id: 'b'+ Date.now(),
          price: Math.round(Math.random() * 100),
          "couponRulesDescribe": "满多少减多少，最多减多少",//优惠券规则描述
          "couponRulesName": "测试券" + Math.round(Math.random() * 10),//优惠券规则名称
          "endTime": "2022年7月28日 10:18:04",//有效期结束时间
          "status": 1,//领取状态:1-待领取 2-自动发放
        }
      }
      let list = [
        getBaseDataCouponItem(getOpt()),
        getBaseDataCouponItem(getOpt(),{
          couponType:"DC",
          price:"8.6",
        }),
        getBaseDataCouponItem(getOpt(),{status:2,}),
      ];
      let data = {
        data:{
          code:200,
          datas:list,
        }
      }
      return Promise.resolve(data);
    },
    /**
     * 从列表中提取需要手动领取的优惠券列表
     */
    getNeedAllotList(list=[]){
      list = list.filter(res=>res.status===1)
      this.needAllotList = list;
    },
    /**
     * 领取优惠券
     */
    allotCoupon(){
      const url = "/api/bns/getCoupon";
      const data = this.needAllotList;
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.$message.success("领取优惠券成功,快去使用吧!");
          data.forEach(res=> res.status = 2);
          this.needAllotList = [];
          this.couponList.forEach(res=> res.status = 2)
          return res;
        })
        .catch(res=>{
          this.$message.error("领取优惠券失败，" + (res.message||"请稍后重试"));
          return Promise.reject(res);
        })
    },
    /**
     * 标记优惠券推送记录
     */
    markCouponRecord(){
      if(this.hasMarkCouponRecord) return Promise.resolve({message:"已标记过"});
      this.hasMarkCouponRecord = true;
      const url = "/api/bns/popUpMark";
      const data = this.couponList;
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          console.log("标记优惠券列表成功");
        })
        .catch(res=>{
          console.error("标记优惠券列表失败",res.message);
        })
    },
  },
  activated() {
    // if(this.$store.getters.token) this.getCouponList();
  },
}
</script>

<style scoped lang="scss">
.coupon-list{
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  &:not(.is-scroll){
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &.is-scroll{
    overflow-x: hidden;
    overflow-y: auto;
    /* 滚动条样式 */
    &::-webkit-scrollbar {
      width: 1px; /*滚动条宽度*/
      height: 1px; /*滚动条高度*/
    }
    /*定义滚动条轨道 内阴影+圆角*/
    &::-webkit-scrollbar-track {
      border-radius: 0; /*滚动条的背景区域的圆角*/
    }
    /*定义滑块 内阴影+圆角*/
    &::-webkit-scrollbar-thumb {
      border-radius: 0; /*滚动条的圆角*/
      background-color: transparent; /*滚动条的背景颜色*/
    }
  }
}
.coupon-li{
  margin-left: auto;
  margin-right: auto;
  & + & {
    margin-top: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// common/getCoupon/index.vue